/* eslint-disable */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import config from '../../../config/config';
import './EditableStatusTable.css';

const { API_BASE_URL } = config;

const EditableStatusTable = ({
  data,
  columns,
  itemsPerPage,
  onPageChange,
  totalRecords,
  dataLoading,
  downloadURL,
  statuChangeURL,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [currentData, setCurrentData] = useState([]);
  const [editedStatus, setEditedStatus] = useState({});
  const { showPopup } = usePopupManager();

  useEffect(() => {
    setCurrentData(data);
  }, [data]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    onPageChange(selected + 1);
  };

  const handleDownload = async (fileName) => {
    const token = localStorage.getItem('ApiToken');
    try {
      const response = await axios.post(
        // `${API_BASE_URL}/api/file-upload-maker-download`,
        `${API_BASE_URL}${downloadURL}`,
        { file_name: fileName },
        {
          headers: { Authorization: `Bearer ${token}` },
          // headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
          responseType: 'blob',
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Download failed:', error);
      showPopup({
        type: MESSAGE_TYPE.ERROR,
        contextText: MESSAGE_TYPE.ERROR,
        info: `Failed to download ${fileName}`,
      });
    }
  };

  const handleSaveStatus = async (row) => {
    const updatedStatus = editedStatus[row.id]?.status || row.status;
    const updatedComment = editedStatus[row.id]?.comment || '';

    if (updatedStatus === 'Rejected' && updatedComment.trim() === '') {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: 'Please provide a comment when rejecting the file.',
      });
      return;
    }

    try {
      const token = localStorage.getItem('ApiToken');
      await axios.post(
        // `${API_BASE_URL}/api/file-upload-update-status`,
        `${API_BASE_URL}${statuChangeURL}`,
        {
          id: row.id,
          status: updatedStatus,
          comment: updatedComment,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: 'Basic YWRtaW4xOjEyMw==',

          },
        }
      );

      setCurrentData((prev) =>
        prev.map((r) =>
          r.id === row.id
            ? {
              ...r,
              status: updatedStatus,
              comments: updatedComment,
            }
            : r
        )
      );
      
      setEditedStatus((prev) => {
        const updated = { ...prev };
        delete updated[row.id];
        return updated;
      });

      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Status updated to "${updatedStatus}" for ID ${row.id}`,
      });

      // showPopup({
      //   type: MESSAGE_TYPE.INFORMATION,
      //   contextText: MESSAGE_TYPE.INFORMATION,
      //   info: `Status updated to "${updatedStatus}" for ID ${row.id}`,
      // });
    } catch (error) {
      console.error('Status update failed', error);
      // alert('Failed to update status');
      showPopup({
        type: MESSAGE_TYPE.ERROR,
        contextText: MESSAGE_TYPE.ERROR,
        info: 'Failed to update status',
      });
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return (
    <div>
      <div className="table-container">
        <p className="total-records mb-2">Total Records: {totalRecords}</p>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>File Name</th>
              <th>Created Date</th>
              <th>Updated Date</th>
              <th>Created Name</th>
              <th>Approved Name</th>
              <th>Download</th>
              <th>Status</th>
              <th>Comment</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {dataLoading ? (
              <tr>
                <td colSpan={columns.length + 2} className="text-center py-4">
                  <div className="spinner-border text-primary mb-3" role="status"></div>
                  <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Please wait..</div>
                </td>
              </tr>
            ) : (
              currentData.map((row) => {
                const isApproved = row.status === 'Approved';
                const isRejected = row.status === 'Rejected';
                const isFinalized = isApproved || isRejected;

                const currentStatus = editedStatus[row.id]?.status || row.status;
                const currentComment =
                  editedStatus[row.id]?.comment ??
                  (isFinalized ? row.comments || '' : '');

                return (
                  <tr key={row.id} className={isFinalized ? 'finalized' : ''}>
                    <td>{row.id.toString().padStart(5, '0')}</td>
                    <td>{row.file_name}</td>
                    <td>
                      <i className="fa fa-calendar me-1 text-muted"></i>
                      {/* {row.created_date} */}
                      {formatDateTime(row.created_date)}
                    </td>
                    <td>
                      <i className="fa fa-calendar me-1 text-muted"></i>
                      {/* {row.updated_date} */}
                      {formatDateTime(row.updated_date)}
                    </td>
                    <td>{row.user_id}</td>
                    <td>{row.approved_name}</td>
                    <td className="text-center">
                      <button
                        className="btn"
                        onClick={() => handleDownload(row.download_file_path)}
                        disabled={!row.download_file_path}
                      >
                        <i className="fa fa-download text-primary" />
                      </button>
                    </td>
                    <td>
                      <select
                        className={`form-select form-select-sm ${currentStatus === 'Approved'
                          ? 'bg-success text-white'
                          : currentStatus === 'Rejected'
                            ? 'bg-danger text-white'
                            : ''
                          }`}
                        style={{ fontSize: '12px', width: "100px" }}
                        value={currentStatus}
                        onChange={(e) =>
                          setEditedStatus((prev) => ({
                            ...prev,
                            [row.id]: {
                              ...prev[row.id],
                              status: e.target.value,
                            },
                          }))
                        }
                        disabled={isFinalized}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${isFinalized ? 'bg-light text-muted' : ''}`}
                        placeholder="Add comment"
                        style={{ fontSize: '12px', width: '160px' }}
                        value={currentComment}
                        onChange={(e) =>
                          setEditedStatus((prev) => ({
                            ...prev,
                            [row.id]: {
                              ...prev[row.id],
                              comment: e.target.value,
                            },
                          }))
                        }
                        readOnly={isRejected}
                        disabled={isApproved}
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary small-save-btn"
                        onClick={() => handleSaveStatus(row)}
                        disabled={
                          isFinalized ||
                          !editedStatus[row.id] ||
                          (editedStatus[row.id]?.status === row.status &&
                            !editedStatus[row.id]?.comment)
                        }
                      >
                        Save
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(totalRecords / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          activeClassName="active"
        />
      </div>
    </div>
  );
};

export default EditableStatusTable;
